
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/research-studies/ai-powered-pedagogy-nursing",
      function () {
        return require("private-next-pages/research-studies/ai-powered-pedagogy-nursing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/research-studies/ai-powered-pedagogy-nursing"])
      });
    }
  